import { createContext, FC, useContext, PropsWithChildren } from 'react';
import { GlobalSettings } from '../../../__generated__/loma';

export const DEFAULT_GLOBAL_SETTINGS_CONTEXT = {
  giftSharingEnabled: undefined,
  internationalDateFormatting: undefined,
  retailerLevelOptInEnabled: undefined,
  hipaaCompliant: undefined,
  retailerName: undefined,
  orderLevelOptInEnabled: undefined,
  smsDefaultCountry: undefined,
  trackPageAssistPortalLinkEnabled: undefined,
};

interface GlobalSettingsProviderValue {
  globalSettings: GlobalSettings;
}

interface GlobalSettingsProviderProps {
  value: GlobalSettingsProviderValue;
}

const GlobalSettingsContext = createContext<GlobalSettingsProviderValue>({
  globalSettings: DEFAULT_GLOBAL_SETTINGS_CONTEXT,
});

export const GlobalSettingsProvider: FC<
  PropsWithChildren<GlobalSettingsProviderProps>
> = ({ value: { globalSettings }, children }) => (
  <GlobalSettingsContext.Provider value={{ globalSettings }}>
    {children}
  </GlobalSettingsContext.Provider>
);

export const useGlobalSettings = () => {
  const context = useContext(GlobalSettingsContext);
  if (!context) {
    throw new Error(
      'useGlobalSettings was called without a GlobalSettingsContext',
    );
  }
  return context.globalSettings;
};
